import React, { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";
import { apiError } from "@/lib/errors";
import { roleLabel } from "@/context/AuthContext";
import { UserAssignmentFields } from "@/components/admin/ScopeFields";

export default function EditUserDialog({ target, roles, sports, isSelf, onClose, onDone }) {
  const [name, setName] = useState(target.name);
  const [role, setRole] = useState(target.role);
  const [scope, setScope] = useState({
    association_id: target.association_id || "", school_id: target.school_id || "", sport_ids: target.sport_ids || [],
  });
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      await api.patch(`/users/${target.id}`, { name, role, ...scope });
      toast.success("User updated");
      onDone(); onClose();
    } catch (e) { toast.error(apiError(e)); } finally { setSaving(false); }
  };

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="rounded-none border-2 border-[#0A1128] max-w-lg" data-testid="edit-user-dialog">
        <DialogHeader><DialogTitle className="font-heading text-2xl">EDIT USER</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div>
            <Label>Name</Label>
            <Input value={name} onChange={e => setName(e.target.value)} className="rounded-sm" data-testid="edit-user-name"/>
          </div>
          <div>
            <Label>Role</Label>
            <Select value={role} onValueChange={setRole} disabled={isSelf}>
              <SelectTrigger className="rounded-sm" data-testid="edit-user-role"><SelectValue/></SelectTrigger>
              <SelectContent>{roles.map(r => <SelectItem key={r} value={r}>{roleLabel(r)}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <UserAssignmentFields role={role} value={scope} onChange={setScope} sports={sports} testidPrefix="edit-user-scope"/>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} className="rounded-sm">Cancel</Button>
          <Button onClick={save} disabled={saving} className="rounded-sm bg-[#0A1128] hover:bg-slate-800" data-testid="edit-user-save">
            {saving ? "Saving..." : "Save"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
